import React from 'react';
import classNames from 'classnames';
import idgen from 'app/lib/idgen';
import constants from 'modules/app/constants/materialize';

import Input from './Input';

class Select extends React.Component {

    renderOptions() {
        let items = [],
            {options, optionLabel, optionValue} = this.props;

        for (let i = 0; i < options.length; i++) {
            let opt = options[i];

            let label = optionLabel ? opt[optionLabel] : opt;
            let value = optionValue ? opt[optionValue] : opt;

            items.push(<option key={value} value={value}>{label}</option>);
        }

        return items;
    }

    render() {
        return (<Input
            type="select"
            {...this.props}>
            {this.renderOptions()}
        </Input>);
    }

}

Select.propTypes = {
    options: React.PropTypes.array.isRequired,
    optionLabel: React.PropTypes.string,
    optionValue: React.PropTypes.string
};

export default Select;